import Landing from '../Landing';

const User = () => <Landing title={__('just joined the network')} />;

export default User;
